export default __webpack_public_path__ + "static/media/blog-oliva.018efe52.jpg";